function baseLt(e,t){return e<t}module.exports=baseLt;